import React from 'react';
import noticeBoard from'NOTICEBOARD/CommonResources/StartUpScreen/images/noticeBoard.gif';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import config from 'config';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import NoticeboardAPICall from 'NoticeboardAPICall';
import ButtonLoader from '../ButtonLoader/ButtonLoader';
import RouteMenu from '../RoutingMenu/RouteMenu';
import NoticeBoard from 'NOTICEBOARD/Components/NoticeBoard';
import noticeImage from 'NOTICEBOARD/CommonResources/StartUpScreen/images/Group.svg';
import analysis from 'NOTICEBOARD/CommonResources/StartUpScreen/images/analysis.svg';
import backGroundImage from 'NOTICEBOARD/CommonResources/StartUpScreen/images/backGroundImage.png'

class StartUpScreen extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            showLoader: false,
            successModal: false,
            successModalType: '',
            successMessage: '',

            subscriptionModelList: {},
            isHavingSubscription: false,
        };
    }

    componentDidMount() {
        this.apiCallToGetSubscriptionModelList();
    }
 
    // // API METHOD TO GET ACCESS DETAILS
    apiCallToGetSubscriptionModelList = async () => {
        let requestData = {
            iid: config.institute_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetPMCurrentSubscriptionWiseModuleList",
            requestData,
            "/api/helpDesk/employee/Onboarding.php"
        );
        
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetSubscriptionModelList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let keysOfSubscriptionModelList = Object.keys(jsonResponse.APIResult.data)
                // WHILE CHECKING FOR MODULE UNIQUE ID IN EVERY MODULE PASS UNIQUE ID AS A STRING 
                let isHavingSubscription = keysOfSubscriptionModelList.includes('42')
                this.setState({
                    showLoader: true
                })
                if (isHavingSubscription) {
                    this.setState({
                        isHavingSubscription: true,
                    });
                }
                if (jsonResponse.APIResult.data)
                    this.setState({
                        subscriptionModelList: jsonResponse.APIResult.data,
                    });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: "error",
                    successMessage:
                        "Something went wrong while getting subscription model access data list. Please try again later.",
                });
            }
        }
    };

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render () {
        return(
            <>
                <div className="startScreen-container">
                    <div style={{ display: 'none' }}>
                        <RouteMenu activeScreen="start" />
                    </div>
                </div>
                <div className="startup-container-startup mt-3">
                    <div className="container col-md-12" style={{ height : '100vh'}}>
                        <div className="enquiry-generation-text row col-md-12 rounded" style = {{ height:'70vh' , backgroundImage: `url(${backGroundImage})`,backgroundSize: 'cover'}}>
                            <div className='col-md-5 p-0 align-self-center' >
                                <p className="features-title " style={{color:'white',fontSize:'20px',fontWeight:'800'}}>Streamline communication : Unleashing the potential of notice board.</p>
                                <div className="navigation-buttons mt-2 ">
                                    {
                                        !this.state.showLoader ?
                                            <ButtonLoader />
                                            :
                                            this.state.isHavingSubscription ?
                                                <>
                                                    {
                                                        config.account == 'faculty' ?
                                                            <button onClick={() => this.props.history.push({ pathname: "/noticeboard" })} className="btn outline-button waves-effect my-payroll fw-bold rounded-pill font-weight-bold">Access Notice board</button>
                                                            :
                                                            <button onClick={() => this.props.history.push({ pathname: "/studentNoticeDashboard" })} className="btn outline-button waves-effect my-payroll fw-bold rounded-pill font-weight-bold">Access Notice board</button>
                                                    }
                                                </>
                                                :
                                                <button onClick={(e) => this.setState({ successModal: true, successModalType: "warning", successMessage: "This module is not part of your subscription.", })} className="btn outline-button waves-effect my-payroll rounded-pill font-weight-bold"> Access Notice Board</button>
                                    }
                                </div>

                            </div>
                            <div className="admission-text col-md-7 col-sm-12 d-flex p-0 align-self-center">
                                <div >
                                  <a href="https://portal.vmedulife.com/modules/lms/#/coursedetails/MjY1NzY=/NDI=">
                                     <img className="grievance-images" src={noticeBoard} style={{width:'80%',borderRadius:"55px 0 0 0",marginLeft:'11%'}} />
                                  </a>
                                </div>
                            </div>
                            {/* <div className="admission-img col-md-6 col-sm-12"> </div> */}
                        </div>
                        <div className="manage-enquiries-text d-flex shadow rounded" style={{ height:'30vh'}}>
                            <div className="admission-img col-md-6 col-sm-12 d-flex align-self-center">
                                <div className='col-1'>  <img src= {noticeImage} /> </div>
                                <div className='col-10' >
                                    <p style={{  fontWeight: 'bold', fontSize: 16 }}>Post Notice</p>
                                    <p style={{ textAlign: 'justify', fontSize: 14 }}>Post the notice for the particular category assigned to you and select the custom assignee to whom the notice should be displayed.</p>
                                </div>                            
                            </div>
                            <div className="admission-text col-md-6 col-sm-12 d-flex align-self-center">
                                 <div className='col-1'>  <img src= {analysis} />   </div>
                                 <div className='col-10'>
                                    <p style={{  fontWeight: 'bold', fontSize: 16 }}>Analysis</p>
                                    <p style={{ textAlign: 'justify', fontSize: 14 }}>View the analysis of the notice such as read history and notification history. You can notify the assignees again if they have not read the notice.</p>
                                 </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                    </div>
                </div>

                {
                    this.state.successModal &&
                        <SuccessModal 
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
            </>
        );
    }
}

export default StartUpScreen;